//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import config from '~/config'
import portal from '~/net/portal'
export default {
    data() {
        return {
            businessBrowserUrl: config.businessBrowserUrl,
            urlList: [
                'https://www.jssic.cn/#/kjzy/kjrc/kjrcList',
                'https://www.jssic.cn/#/kjzy/kjzt/kyjgList/bskyjg',
                'https://www.jssic.cn/#/kjzy/kjjc/gcjsList',
                'https://www.jssic.cn/#/kjzy/kjcg/kjcgList',
                'https://www.jssic.cn/#/kjzy/kjfw/gjkjhzList',
                'https://www.jssic.cn/#/map',
                'https://www.jssic.cn/kjzc/#/home',
                'https://yqgx.jssic.cn/#/index',
                'https://www.jssic.cn/#/kjsc/jcfwList',
                'https://www.jssic.cn/#/kjsc/jsyffwList',
                'https://www.jssic.cn/#/kjsc/zzzyList',
                'https://www.jssic.cn/swyb/#/login',
                'https://www.jstec.com.cn/',
                'https://www.jssic.cn/#/zxzx/zxywList',
                'https://www.jssic.cn/#/zxzx/kjdtList',
                'https://www.jssic.cn/#/zxzx/mtjjList',
                'https://www.jssic.cn/#/zxzx/tzggList'
            ]
        }
    },
    computed: {
        ...mapState(['user'])
    },
    mounted() {},
    destroyed() {},
    methods: {
        jump(index) {
            window.open(this.urlList[index])
        },
        jumpUrl(url) {
            window.open(url)
        },
        pushCenter() {
            window.location.href = `${this.businessBrowserUrl}/demandCrowdManagement?role=buyer&activityId=202413602956578655`
        }
    }
}
